import React from 'react'
import styles from './Button.module.sass'

export default function Button({
  type = 'button',
  icon = null,
  iconPos = 'right',
  label = '',
  variant = 'primary',
  size = 'md',
  responsive = false,
  href = null,
  disabled = false,
  onClick = undefined,
  className = '',
}) {

  const classNames = `${styles.root} ${styles[`root--${variant}`]} ${styles[`root--${size}`]} ${responsive ? styles['root--responsive'] : ''} ${className}`
  
  const content = (
    <>
      {!!icon && iconPos === 'left' && <span className={`${styles.icon} ${styles['icon--left']}`}>{icon}</span>}
      {!!label && <span className={styles.label}>{label}</span>}
      {!!icon && iconPos === 'right' && <span className={`${styles.icon} ${styles['icon--right']}`}>{icon}</span>}
    </>
  )

  return href ? (
    <a href={href} className={classNames} onClick={onClick}>
      {content}
    </a>
  ) : (
    <button type={type} disabled={disabled} className={classNames} onClick={onClick}>
      {content}
    </button>
  )
}
